
export class TypeScriptLibrary
{
  public static readonly token = "typescript";
  public static keywords:string[] = 
  [
    "string","number","undefined",
    "export","static","new"
  ]
  ;

  public static keywords2:string[] = 
  [
  ]
  ;
  
}